<template>
  <div>
    <ok-cancel-modal
      :title="$t('health.nutritionalPlan.foodsSelector')"
      :ok-button="okButtonLabel"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk"
      v-on:cancel="$emit('close')">
      <div
        slot="body">
        <div
          v-if="selectedFoods.length > 0"
          class="selected-basket">
          <h4 class="selected-basket__title">
            {{ $t('health.nutritionalPlan.selectedFoodsCount', { count: selectedFoods.length }) }}
          </h4>
          <ul class="selected-basket__list">
            <li
              v-for="food in selectedFoods"
              :key="food.food_id"
              class="selected-basket__item">
              <span class="selected-basket__name">{{ food.food_name }}</span>
              <button
                type="button"
                class="selected-basket__remove"
                :aria-label="$t('commons.delete')"
                @click="removeSelectedFood(food)">
                ✕
              </button>
            </li>
          </ul>
        </div>
        <search-input
          ref="foodSearch"
          class="search-input"
          :focus="true"
          v-on:input="onChangeFilter"/>
        <div
          class="margin-top-xl food-list">
          <h3
            class="margin-bottom-l">
            {{ $t('health.nutritionalPlan.foods') }}
          </h3>
          <checkbox
            v-for="(food, index) in getFilteredFoods.slice(0, maxFoodsToShow)"
            :key="index"
            :id="String(food.food_id)"
            :label="food.food_name"
            :checked="isChecked(food)"
            v-on:change="() => onVariableSelected(food)"/>
          <div
            v-if="getFilteredFoods.length > maxFoodsToShow"
            class="and-x-more">
            {{ $t('variables.andXMore', {count: foodToShow() })}}
          </div>
        </div>
      </div>
    </ok-cancel-modal>
  </div>
</template>

<script>
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import SearchInput from '@/components/shared/SearchInput';
import Checkbox from '@/components/shared/forms/Checkbox';

export default {
  name: 'AddFoodModal',
  components: {
    OkCancelModal,
    SearchInput,
    Checkbox
  },
  props: {
    foods: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      foodFilter: '',
      selectedFoods: [],
      maxFoodsToShow: 50
    };
  },
  computed: {
    getFilteredFoods () {
      if (this.foodFilter !== '') {
        return this.foods.filter(food => {
          return replaceSpecialChars(food.food_name.toUpperCase()).includes(replaceSpecialChars(this.foodFilter.toUpperCase()));
        });
      }
      return this.foods;
    },
    okButtonLabel () {
      if (this.selectedFoods.length <= 1) return this.$t('commons.ok');
      return this.$t('commons.ok') + ' (' + this.selectedFoods.length + ')';
    }
  },
  methods: {
    isChecked (food) {
      return this.selectedFoods.some(f => f.food_id === food.food_id);
    },
    onVariableSelected (food) {
      const idx = this.selectedFoods.findIndex(f => f.food_id === food.food_id);
      if (idx === -1) {
        this.selectedFoods.push(food);
      } else {
        this.selectedFoods.splice(idx, 1);
      }
    },
    removeSelectedFood (food) {
      this.selectedFoods = this.selectedFoods.filter(f => f.food_id !== food.food_id);
    },
    onOk () {
      this.$emit('input', this.selectedFoods);
      this.$emit('close');
    },
    onChangeFilter (filter) {
      this.foodFilter = filter;
    },
    foodToShow () {
      return this.getFilteredFoods.length - this.maxFoodsToShow;
    }
  }
};

const replaceSpecialChars = (str) => {
  return str.normalize('NFD').replace(/[̀-ͯ]/g, '') // Remove accents
    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
    .replace(/(^-+|-+$)/g, ''); // Remove extra hyphens from beginning or end of the string
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

$accent: #F35647;

h3 {
  color: $jamaicol;
}

.food-list {
  min-height: calc(100vh / 2);
  max-height: calc(100vh / 2);
  overflow-y: auto;
}

.search-input {
  margin-bottom: $sp-margin;
}

.and-x-more {
  color: $jamaicol;
}

.selected-basket {
  margin-bottom: $sp-margin;
  padding: 0.75em 1em;
  background-color: rgba($accent, 0.08);
  border: 1px solid rgba($accent, 0.25);
  border-radius: $radius;

  &__title {
    margin: 0 0 0.5em 0;
    font-size: 0.95em;
    color: $jamaicol;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.4em;
  }

  &__item {
    display: inline-flex;
    align-items: center;
    gap: 0.4em;
    padding: 0.3em 0.6em;
    background-color: $white;
    border: 1px solid rgba($black, 0.15);
    border-radius: 999px;
    font-size: 0.85em;
  }

  &__name {
    color: $bodycolor;
  }

  &__remove {
    background: none;
    border: none;
    color: $accent;
    cursor: pointer;
    padding: 0;
    font-size: 0.9em;
    line-height: 1;

    &:hover {
      color: #F46355;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/AddFoodModal.vue